export default ({onClick}) => {
	return (
		<div className="floatingBtnGoUp" onClick={onClick}>
			<span className="mdi-arrow-up"></span>
		</div>
	);
};
